import { HeroTestimonialRotator } from "../HeroTestimonialRotator";
import { VAULT } from "../../data/vaultStats";

const STATS = [
  [VAULT.tracksFmt, "Income playbooks"],
  [VAULT.promptsFmt, "Quality-reviewed prompts"],
  [VAULT.customersClaim, "Customers across Stag Vault products"],
  ["£25", "One lifetime payment"],
];

export const LandingProofBand = () => (
  <section className="border-b border-white/10 bg-[#08070a]" data-testid="landing-proof-band">
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:px-6 md:px-10 lg:grid-cols-12 lg:items-center lg:py-12">
      <div className="grid grid-cols-2 gap-x-6 gap-y-7 sm:grid-cols-4 lg:col-span-7" data-testid="about-stats">
        {STATS.map(([value, label]) => (
          <div key={label} className="border-l border-purple-400/40 pl-3">
            <div className="font-display text-2xl font-black text-white sm:text-3xl">{value}</div>
            <div className="mt-1 text-xs leading-snug text-zinc-500">{label}</div>
          </div>
        ))}
      </div>
      <div className="border-t border-zinc-800 pt-6 lg:col-span-5 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0">
        <div className="mb-3 font-mono text-[10px] uppercase tracking-[0.2em] text-purple-300">From verified members</div>
        <HeroTestimonialRotator />
      </div>
    </div>
  </section>
);